import { gettext } from '../../services'

const FEATURES_LIST = (
    '<ul class="premium-features-list columns mt mb">' +
        '<li>' +
            '<svg class="feature-icon-premium"><use xlink:href="#premium-feature-icon-navigation"/></svg>' +
            gettext('Turn-by-turn Navigation') +
        '</li>' +
        '<li>' +
            '<svg class="feature-icon-premium"><use xlink:href="#premium-feature-icon-offline-maps"/></svg>' +
            gettext('Offline Maps & Routes') +
        '</li>' +
        '<li>' +
            '<svg class="feature-icon-premium"><use xlink:href="#premium-feature-icon-bike-type-optimized-routing"/></svg>' +
            gettext('Bike-Type Optimised Routing') +
        '</li>' +
        '<li>' +
            '<svg class="feature-icon-premium"><use xlink:href="#premium-feature-icon-bike-computer"/></svg>' +
            gettext('Custom Bike Computer') +
        '</li>' +
        '<li>' +
            '<svg class="feature-icon-premium"><use xlink:href="#premium-feature-icon-map-navigation"/></svg>' +
            gettext('Advanced Cycling Maps') +
        '</li>' +
        '<li>' +
            '<svg class="feature-icon-premium"><use xlink:href="#premium-feature-icon-export"/></svg>' +
            gettext('Export Routes') +
        '</li>' +
        '<li>' +
            '<svg class="feature-icon-premium"><use xlink:href="#premium-feature-icon-route-previews"/></svg>' +
            gettext('Detailed Route Previews') +
        '</li>' +
        '<li>' +
            '<svg class="feature-icon-premium"><use xlink:href="#premium-feature-icon-fall-detection"/></svg>' +
            gettext('Fall Detection') +
        '</li>' +
        '<li>' +
            '<svg class="feature-icon-premium"><use xlink:href="#premium-feature-icon-premium-support"/></svg>' +
            gettext('Premium Support') +
        '</li>' +
    '</ul>'
)

export { FEATURES_LIST }
